// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { OwnerCreditCardFragment } from '../../fragments/generated/owner-credit-card.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetOwnerCreditCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOwnerCreditCardQueryResult = { __typename?: 'Query', getOwnerCreditCard: { __typename?: 'OwnerCreditCardDTO', addCards: boolean, causalCancelPreauth: string | null, causalCharge: string | null, causalConfirm: string | null, causalPreautorization: string | null, causalRefund: string | null, chargeWithoutInvoice: boolean, checkCards: boolean, currencyIsoCode: string, defaultOwnerPaymentGatewayId: number | null, deleteCards: boolean, viewCards: boolean, viewCardsCvv: boolean } | null };

export const GetOwnerCreditCardGql = gql`
    query GetOwnerCreditCard {
  getOwnerCreditCard {
    ...OwnerCreditCard
  }
}
    ${OwnerCreditCardFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOwnerCreditCardInjectable extends Apollo.Query<GetOwnerCreditCardQueryResult, GetOwnerCreditCardQueryVariables> {
    override document = GetOwnerCreditCardGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */